// removed by extract-text-webpack-plugin
module.exports = {"place-details":"place-details__2K7SF","summary-and-meta":"summary-and-meta__2Ifkd","summary":"summary__3-ck_","content":"content__3E6mT","meta":"meta__IEsbP","location":"location__4tWfO","contacts":"contacts__3uu8y","url":"url__1dMRt","email":"email__vUeea","tel":"tel__2pw4g","map-container":"map-container__2OzQL"};


//////////////////
// WEBPACK FOOTER
// ./app/scripts/views/App/views/Place/styles.scss
// module id = ./app/scripts/views/App/views/Place/styles.scss
// module chunks = 1